import { TableColumnMeta } from "ds/components/Table/types";

import { ActionsColumnId } from "./globalTable";

export enum EnvVariablesColumnId {
  NAME = "name",
  DESCRIPTION = "description",
  VALUE = "value",
  SOURCE = "source",
  CREATED_AT = "createdAt",
  ACTIONS = ActionsColumnId.ACTIONS,
}

export const ENV_VARS_COLUMNS: Record<
  Exclude<EnvVariablesColumnId, EnvVariablesColumnId.ACTIONS>,
  TableColumnMeta
> = {
  [EnvVariablesColumnId.NAME]: {
    id: EnvVariablesColumnId.NAME,
    title: "Name",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.DESCRIPTION]: {
    id: EnvVariablesColumnId.DESCRIPTION,
    title: "Description",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.VALUE]: {
    id: EnvVariablesColumnId.VALUE,
    title: "Value",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.SOURCE]: {
    id: EnvVariablesColumnId.SOURCE,
    title: "Source",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.CREATED_AT]: {
    id: EnvVariablesColumnId.CREATED_AT,
    title: "Created at",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
};
